export default __webpack_public_path__ + "static/team-member-01-370x455-78b38159321baca69020a932ace872ad.jpg";